module.exports = __webpack_public_path__ + "img/WEATHER-NET.f7cb449c.jpeg";